/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import parseCookie from "../../../utils/helpers/parse-cookie";
import loadable from "@loadable/component";
import { sendCustomGaEvents } from "../../../tracking";
import { appointmentTimeout } from "../../../constants/tracking-constants/user-drop";
import Skeleton from "./skeleton";
import { STEP_NAMES } from "../../../constants/app-constants";
const LeadFormWrapper = loadable(() => import("../lead-form-revamp-wrapper"));
const SellerWidget = loadable(() => import("../seller-widget"));

// eslint-disable-next-line max-statements
const LeadFormAndWidgetWrapper = ({
    user,
    leadData,
    widgetData,
    fetchDataConnect,
    setShowWidgetConnect,
    fetchDataSuccessConnect,
    ctaText,
    isBrandsVisible,
    isScrapBenefitsVisible = false,
    isUserDrop,
    getRepeatInspectionWidgetConnect,
    setSsrStatusConnect,
    isSSR,
    isError,
    resetUserDropDataConnect,
    allCardInfo,
    userDropExperiment,
    userId,
    setUserCarRegistrationNOConnect,
    isAllianceOffer,
    isLuxuryPage,
    isDlsCompliant,
    setStepConnect,
    askUserIntentConnect,
    activateLastStepConnect,
    showDupModal,
    setShowDupModalConnect
}) => {

    const { secureToken, isLoggedIn, isFetched } = user;
    const [isFetching, setIsFetching] = useState(false);
    const { showWidget, token, activateFirstStep, isLeadFormEdit} = leadData;
    const [isDuplicateAppointment, setIsDuplicateAppointment] = useState(false);
    const [userJourneyComponent, setUserJourneyComponent] = useState(null);
    const [isPhoneNumberChange, setIsPhoneNumberChange] = useState(false);
    const sellOnlineToken = parseCookie("sell_online_lead_token");
    const gaEventHandler = (experimentType, eventLabel, isRevamped) => {
        sendCustomGaEvents({
            event: "Repeat_user_homepage",
            eventCategory: `homepage_revamp_${experimentType ? experimentType.toLowerCase() : experimentType}`,
            eventLabel,
            eventAction: `revamp_${isRevamped}`,
            dimension148: userId
        });
    };

    useEffect(() => {
        setSsrStatusConnect(false);
        if (isError) {
            sendCustomGaEvents(appointmentTimeout);
        }
        if (allCardInfo) {
            setUserCarRegistrationNOConnect("");
            gaEventHandler(userDropExperiment, allCardInfo, isUserDrop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (activateFirstStep || (!isLoggedIn && isFetched)) {
            fetchDataSuccessConnect(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activateFirstStep, isLoggedIn, isFetched]);

    useEffect(() => {
        if (isLeadFormEdit && secureToken && token) {
            setShowWidgetConnect(false);
            activateLastStepConnect(false);
            askUserIntentConnect(false);
            setStepConnect({ currentStep: STEP_NAMES.Brand });
        } else {
            if (secureToken && !isDuplicateAppointment) {
                fetchDataConnect(token, secureToken, "v3")
                    .then(() => {
                        // !showDupModal && setShowWidgetConnect(true);
                    });
            }
            if (secureToken && !showDupModal && ((isUserDrop && !isDuplicateAppointment && !isPhoneNumberChange) || (widgetData.data && widgetData.data.data && !isDuplicateAppointment))) {
                setShowWidgetConnect(true);
            } else {
                setShowWidgetConnect(false);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secureToken, isDuplicateAppointment, showDupModal]);

    useEffect(() => {
        if (isLeadFormEdit && secureToken && token) {
            setShowWidgetConnect(false);
            activateLastStepConnect(false);
            askUserIntentConnect(false);
            setStepConnect({ currentStep: STEP_NAMES.Brand });
            return;
        } else if (sellOnlineToken || (token && !isDuplicateAppointment && !isPhoneNumberChange && isLoggedIn) && !isFetching)  {
            if ((isScrapBenefitsVisible && !showWidget) || showDupModal) {
                setShowWidgetConnect(false);
            } else {
                setShowWidgetConnect(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, showDupModal]);

    useEffect(() => {
        if (!isError && !isSSR && secureToken && !isUserDrop && !isDuplicateAppointment && !isPhoneNumberChange) {
            // setIsFetching(true);
            getRepeatInspectionWidgetConnect(secureToken).then((response) => {
                setUserCarRegistrationNOConnect("");
                const {
                    experimentType: experimentTypeValue = "",
                    allCardInfo: allCardInfoValue = "",
                    isUserDrop: isUserDropValue = ""
                } = response || {};
                if (allCardInfoValue) {
                    gaEventHandler(experimentTypeValue, allCardInfoValue, isUserDropValue);
                }
                if (isUserDropValue && !showDupModal) {
                    setShowWidgetConnect(true);
                }
                setIsFetching(false);
            }).catch(() => {
                sendCustomGaEvents({
                    ...appointmentTimeout,
                    eventAction: "timeout_client"
                });
                setIsFetching(false);
            });
        } else if (isError && !isUserDrop) {
            setIsFetching(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR, secureToken, isUserDrop, isError, isDuplicateAppointment, isPhoneNumberChange, showDupModal]);

    const importUserJourneyComponent = () => {
        if (userJourneyComponent === null) {
            import(/* webpackChunkName: "repeat-user" */ "../user-journey-drop").then((comp) => {
                setUserJourneyComponent(
                    <comp.default
                        isScrapFlow={isScrapBenefitsVisible}
                    />
                );
                setIsFetching(false);
            });
        } else {
            setIsFetching(false);
        }
    };

    useEffect(() => {
        if (secureToken && showWidget && isUserDrop) {
            importUserJourneyComponent();
        } else if (!secureToken) {
            resetUserDropDataConnect();
            setIsFetching(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secureToken, isUserDrop, showWidget]);

    if (isFetching && !isScrapBenefitsVisible && isLoggedIn) {
        return <Skeleton/>;
    }

    if (showWidget && isUserDrop && secureToken && userJourneyComponent && !isDuplicateAppointment && !isPhoneNumberChange && !isScrapBenefitsVisible) {
        return (<React.Fragment>
            {userJourneyComponent}
        </React.Fragment>);
    }

    if (showWidget && isLoggedIn) {
        return <SellerWidget eliteCar={isLuxuryPage} />;
    }

    return (
        <LeadFormWrapper
            setIsFetching={setIsFetching}
            setIsDuplicateAppointment={setIsDuplicateAppointment}
            setShowDupModalConnect={setShowDupModalConnect}
            ctaText={ctaText}
            isBrandsVisible={isBrandsVisible}
            isScrapBenefitsVisible={isScrapBenefitsVisible}
            setIsPhoneNumberChange={setIsPhoneNumberChange}
            isAllianceOffer={isAllianceOffer}
            isLuxuryPage={isLuxuryPage}
            isDlsCompliant={isDlsCompliant}
        />
    );
};

LeadFormAndWidgetWrapper.propTypes = {
    user: PropTypes.object,
    leadData: PropTypes.object,
    widgetData: PropTypes.object,
    fetchDataConnect: PropTypes.func,
    setShowWidgetConnect: PropTypes.func,
    fetchDataSuccessConnect: PropTypes.func,
    ctaText: PropTypes.string,
    isBrandsVisible: PropTypes.bool,
    isScrapBenefitsVisible: PropTypes.bool,
    isUserDrop: PropTypes.bool,
    getRepeatInspectionWidgetConnect: PropTypes.func,
    setSsrStatusConnect: PropTypes.func,
    isSSR: PropTypes.bool,
    isError: PropTypes.bool,
    resetUserDropDataConnect: PropTypes.func,
    allCardInfo: PropTypes.string,
    userDropExperiment: PropTypes.string,
    userId: PropTypes.string,
    setUserCarRegistrationNOConnect: PropTypes.func,
    isAllianceOffer: PropTypes.bool,
    isLuxuryPage: PropTypes.bool,
    isDlsCompliant: PropTypes.bool,
    setStepConnect: PropTypes.func,
    askUserIntentConnect: PropTypes.func,
    activateLastStepConnect: PropTypes.func,
    showDupModal: PropTypes.bool,
    setShowDupModalConnect: PropTypes.func
};

export default LeadFormAndWidgetWrapper;
